/* eslint-disable linebreak-style */
/* eslint-disable react/display-name */
/* eslint-disable react/jsx-props-no-spreading,no-console */
import React, { Fragment } from 'react';
import 'root/state/slices/articles';
import { fetchArticle } from 'root/lib/api.article';
import PropTypes from 'prop-types';
import { fetchSidebar, setSidebar } from 'state/slices/sidebars';
import { fetchMenuFooter, fetchMenuHeader } from 'state/slices/menus';
import { fetchDevices } from 'state/slices/devices';
import ArticleScreen from 'screens/Article';
import SpecialPublicScreen from 'screens/SpecialPublic';
import DiseaseScreen from 'screens/Disease';
import DrugScreen from 'screens/Drug';
import { Sentry } from 'utils/raven';
import * as SentryReact from '@sentry/react';
import dynamic from 'next/dynamic';
import withWP from 'utils/withWP';
import { wrapper } from 'root/state';
import withUA from 'utils/withUA';
import get from 'base-ui/dist/underline/get';
import { requestWrapperUserAgent } from 'root/lib/apiClient';

const Layout = dynamic(() => import('components/Layout'));
const WpBar = dynamic(() => import('components/WpBar'), { ssr: false });
const TaboolaFooter = dynamic(() => import('components/TaboolaWidget').then((t) => t.TaboolaFooter), { ssr: false });
const Error = dynamic(() => import('root/pages/error'));

const getPage = (query, post) => {
  if (post?.sponsor) {
    return 'specialPublic';
  }
  return get(query, 'page', post?.options?.template);
};

const Article = ({ post, page, wpLoggedIn, ...props }) => {
  const defineLayout = () => {
    switch (page) {
      case 'disease': {
        return <DiseaseScreen post={post} {...props} />;
      }
      case 'drug': {
        return <DrugScreen post={post} {...props} />;
      }
      case 'specialPublic': {
        return <SpecialPublicScreen post={post} {...props} />;
      }
      default: {
        return <ArticleScreen post={post} {...props} />;
      }
    }
  };
  if (!post || post.offline) return <Error wpLoggedIn={wpLoggedIn} statusCode={post && post.offline ? 801 : 404} {...props} />;
  return (
    <Fragment>
      <WpBar wpLoggedIn={wpLoggedIn} currentResource={{ id: post.id, type: 'post' }} />
      <Layout>
        {defineLayout()}
        <TaboolaFooter />
      </Layout>
    </Fragment>
  );
};

export const getServerSideProps = withUA(withWP(wrapper.getServerSideProps(
  async ({ res, query, store, req }) => {
    // Set custom user-agent to requests
    requestWrapperUserAgent(req);

    const promises = [];
    const slug = query?.permalink || query?.slug;

    promises.push(store.dispatch(fetchDevices(query)));
    promises.push(store.dispatch(fetchMenuHeader()));
    promises.push(store.dispatch(fetchMenuFooter()));
    promises.push(store.dispatch(fetchSidebar('footer-grid')));

    await Promise.all(promises);

    const post = await fetchArticle(slug);

    Sentry.addBreadcrumb({
      category: 'pages/article',
      message: `Render article (${get(query, 'page', post?.options?.template)}) ${query?.permalink}`,
      level: Sentry.Severity.Debug,
    });

    if (!post) {
      if (res) res.statusCode = 404;
      return { props: { post: null } };
    }
    if (post.offline) {
      if (res) res.statusCode = 801;
      return { props: { post } };
    }

    store.dispatch(setSidebar({
      slug: 'single-sidebar',
      data: post?.sidebars?.right,
    }));

    store.dispatch(setSidebar({
      slug: 'single-lower-sidebar',
      data: post?.sidebars?.bottom,
    }));

    return { props: { post, page: getPage(query, post) } };
  }
)));

Article.propTypes = {
  post: PropTypes.object,
  posts: PropTypes.array,
  page: PropTypes.string,
  wpLoggedIn: PropTypes.bool,
};

export const config = { amp: 'hybrid' };
export default SentryReact.withProfiler(Article);
